/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserLoginComponent } from './components/login/user-login.component';
import { TeamSignupComponent } from './components/tournament/team-signup/team-signup.component';
import { TournamentTeamsComponent } from './components/tournament-teams/tournament-teams.component';
import { UserRegisterComponent } from './components/user-register/user-register.component';
import { AuthGuard } from './guards/auth.guard';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { BeerPongTableCreateComponent } from './components/beer-pong-table-create/beer-pong-table-create.component';
import { BeerPongTableUpdateComponent } from './components/beer-pong-table-update/beer-pong-table-update.component';
import { TournamentsComponent } from './components/tournament/tournaments/tournaments.component';
import { TournamentCreateComponent } from './components/tournament/tournament-create/tournament-create.component';
import { UserDetailComponent } from './components/user-detail/user-detail.component';
import { LoggedInGuard } from './guards/logged-in.guard';
import { TournamentOverviewComponent } from './components/tournament/tournament-overview/tournament-overview.component';
import { TournamentQualificationPhaseComponent } from './components/tournament/tournament-qualification-phase/tournament-qualification-phase.component';
import { BeerPongTableOverviewComponent } from './components/beer-pong-table-overview/beer-pong-table-overview.component';
import { TournamentEditComponent } from './components/tournament/tournament-edit/tournament-edit.component';
import { TournamentPublicViewComponent } from './components/tournament/tournament-public-view/tournament-public-view.component';
import { InfoscreenKnockoutPhaseTreeComponent } from './components/infoscreen-knockout-phase-tree/infoscreen-knockout-phase-tree.component';
import { EditKnockoutPhaseTreeComponent } from './components/tournament/edit-knockout-phase-tree/edit-knockout-phase-tree.component';
import { PartyPicsApproveComponent } from './components/party-pictures-approve/party-pics-approve.component';
import { TournamentPublicGalleryComponent } from './components/tournament/tournament-public-gallery/tournament-public-gallery.component';
import { ImageUploadComponent } from './components/image-upload/image-upload.component';
import {
  InfoscreenKnockoutPhaseFixedComponent
} from "./components/infoscreen-knockout-phase-fixed/infoscreen-knockout-phase-fixed.component";

const routes: Routes = [
  {
    path: 'admin',
    canActivate: [LoggedInGuard],
    component: AuthLayoutComponent,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: UserLoginComponent },
      { path: 'register', component: UserRegisterComponent },
    ],
  },
  {
    path: 'admin',
    component: MainLayoutComponent,
    canActivate: [AuthGuard], // Guard applied at the main layout level
    children: [
      { path: '', redirectTo: '/admin/tournaments', pathMatch: 'full' },
      { path: 'details/:username', component: UserDetailComponent },
      {
        path: 'tournaments',
        children: [
          { path: '', component: TournamentsComponent },
          { path: 'create', component: TournamentCreateComponent },
          {
            path: ':tournamentId',
            children: [
              { path: '', component: TournamentOverviewComponent },
              { path: 'edit', component: TournamentEditComponent },
              { path: 'teams', component: TournamentTeamsComponent },
              { path: 'qualification-phase', component: TournamentQualificationPhaseComponent },
              { path: 'ko-phase', component: EditKnockoutPhaseTreeComponent },
              { path: 'tables', component: BeerPongTableOverviewComponent },
              {
                path: 'tables',
                children: [
                  {
                    path: 'create',
                    component: BeerPongTableCreateComponent,
                  },
                  {
                    path: ':beerPongTableId/update',
                    component: BeerPongTableUpdateComponent,
                  },
                ],
              },
              { path: 'pictures', component: PartyPicsApproveComponent },
            ],
          },
        ],
      },
    ],
  },
  // Must be separate from the below, main routes declaration, as below
  // the `AuthGuard` is applied everywhere.
  // `tournaments/<id>/signup` is a bit special in that it should be "publically"
  // available, so that teams can sign up using their magic link (which just
  // contains a special token), without needing to log in or such.
  { path: 'tournaments/:tournamentId/signup', component: TeamSignupComponent },
  { path: 'tournaments/:tournamentId/upload-image', component: ImageUploadComponent },
  { path: 'tournaments/:tournamentId/live', component: TournamentPublicViewComponent },
  { path: 'tournaments/:tournamentId/public-gallery', component: TournamentPublicGalleryComponent },
  { path: '', component: TeamSignupComponent, title: 'Anmeldung Beerpongturnier | Klub Pfeilheim' },

  {
    path: 'infoscreen/:tournamentId/ko-phase',
    component: InfoscreenKnockoutPhaseTreeComponent,
  },
  {
    path: 'infoscreen/:tournamentId/ko-phase-fixed',
    component: InfoscreenKnockoutPhaseFixedComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
